//------------- Baske Reducers -------------------//

export const BASKET_LOADING = 'BASKET_LOADING';
export const BASKET_ADD = 'BASKET_ADD';
export const BASKET_DELETE = 'BASKET_DELETE';
export const BASKET_EMPTY = 'BASKET_EMPTY';

//---------------- Users Section ----------------//
export const SET_USER = 'SET_USER';
export const REMOVE_USER = 'REMOVE_USER';

//-------------- ORDER ---------------------------//
export const ORDERS_LOADING = 'ORDERS_LOADING';
export const ORDERS_ADD = 'ORDERS_ADD';
export const ORDERS_ERROR = 'ORDERS_ERROR';
